import Poster from 'records/Poster';
import Base from 'records/Base';

import {
  POSTER_ITEM_ASYNC_ACTION_START,
  POSTER_ITEM_ASYNC_ACTION_ERROR,
  POSTER_ITEM_ASYNC_ACTION_SUCCESS,
  POSTER_ITEM_ASYNC_UPDATE_ACTION_SUCCESS,
  POSTER_ITEM_RESET_STATE,
} from 'actions/poster';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new Poster(),
});

const actionsMap = {
  [POSTER_ITEM_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [POSTER_ITEM_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [POSTER_ITEM_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Poster(action.data),
    });
  },
  [POSTER_ITEM_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Poster(action.data),
    });
  },
  [POSTER_ITEM_RESET_STATE]: () => {
    return initialState;
  },
};

export default function poster(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
